import "./assets/scss/base.css";
import ParentApp from "./component/ParentApp";
import { AttributesContextProvider } from "./context/AttributesContext";

import interceptor from "./services/interceptor";
import { ThemeProvider } from "./context/ThemeContext";
interceptor();

function App() {
  return (
    <AttributesContextProvider>
      <ThemeProvider>
        <ParentApp />
      </ThemeProvider>
    </AttributesContextProvider>
  );
}

export default App;
